// !!! DO NOT TOUCH: '@webtrader/core/init' import must be at the top
import '@webtrader/core/init';
import 'normalize.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Router } from 'react-router-dom';

import { history } from '@webtrader/core/router';

import Screens from './screens';

const rootContainer = document.getElementById('root');

if (rootContainer) {
  const root = createRoot(rootContainer);

  root.render(
    <Router history={history}>
      <Screens />
    </Router>
  );
}
